import {formatTimestampEndOfDay, formatTimestampStartOfDay} from "./misc";
import {getActiveAccount} from "../lib/activeMember";
import {httpGet, httpPost, httpPut} from "./http";

const promotionURL = window.env.BACKEND_API_URL + "/promotions";
const promotionCreditsURL = window.env.BACKEND_API_URL + "/promotion_credits";

//region REST

const getAllPromotions = async (page, pageSize, filter, signal) => {
    let getPromotionsURL = `${promotionURL}?page=${page}&per_page=${pageSize}&filter=${filter}`;

    return await httpGet(getPromotionsURL, signal);
};

const getAllPromotionCredits = async (page, pageSize, filter, signal) => {
    let getPromoCreditsURL = `${promotionCreditsURL}?page=${page}&per_page=${pageSize}&filter=${filter}&account_id=${getActiveAccount().id}`;

    return await httpGet(getPromoCreditsURL, signal);
};

const createPromotion = async ({
                                   name,
                                   promo_code,
                                   default_amount,
                                   started_at,
                                   ended_at,
                                   credits_default_ended_at,
                                   credits_default_duration,
                                   credits_max_num_total,
                                   credits_max_num_account
                               }, signal) => {
    // Format dates if they exist.
    const body = {
        name,
        promo_code: promo_code ? promo_code.toUpperCase() : null, // Make promo_code uppercase before B/E validation.
        default_amount,
        started_at: formatTimestampStartOfDay(started_at),
        ended_at: ended_at ? formatTimestampEndOfDay(ended_at) : null,
        credits_default_ended_at: credits_default_ended_at ? formatTimestampEndOfDay(credits_default_ended_at) : null,
        credits_default_duration,
        credits_max_num_total,
        credits_max_num_account
    };

    return await httpPost(promotionURL, body, signal);
}

const createPromotionalCredit = async ({promotion_id, started_at}, signal) => {
    const body = {
        promotion_id,
        started_at: formatTimestampStartOfDay(started_at),
        account_id: getActiveAccount().id,
    };

    return await httpPost(promotionCreditsURL, body, signal);
}

const updatePromotion = async ({
                                   name,
                                   promo_code,
                                   started_at,
                                   ended_at,
                                   default_amount,
                                   credits_default_ended_at,
                                   credits_default_duration,
                                   credits_max_num_total,
                                   credits_max_num_account
                               }, promoID, signal) => {

    const updateURL = `${promotionURL}/${promoID}`;
    const body = {
        name,
        promo_code,
        started_at,
        ended_at,
        default_amount,
        credits_default_ended_at,
        credits_default_duration,
        credits_max_num_total,
        credits_max_num_account
    }

    return await httpPut(updateURL, body, signal);
}

//endregion

export {
    getAllPromotions,
    getAllPromotionCredits,
    createPromotion,
    createPromotionalCredit,
    updatePromotion,
};
